import React from 'react';
import RestaurantPromotions from './RestaurantPromotions';

const NewRestaurantPromotions = () => {
  return <RestaurantPromotions />;
};

export default NewRestaurantPromotions;




